import styled from 'styled-components'

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  div:first-child {
    ${props => props.theme.typography.latoReg};
    font-size: 16px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    color: ${props => props.theme.colors.smalt};
  }
  div + div {
    display: flex;
    a {
      width: 30px;
      height: 30px;
      margin-left: 10px;
      svg {
        width: 100%;
        height: 100%;
      }
    }
  }
`

export default Wrapper
